import { StaticImage } from 'gatsby-plugin-image';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import CommunityCTA from 'components/CommunityCTA';
import * as React from 'react';
export default {
  StaticImage,
  getImage,
  GatsbyImage,
  CommunityCTA,
  React
};